import { Table } from "react-bootstrap";
import { useDispatch, useStore } from "react-redux";
import { useCallback, useState } from "react";

import TableHeader from "./components/TableHeader";
import MaxBetrag from "./components/MaxBetrag";
import { updateLieferadresse } from "../reducers/lieferadressen-reducer";
import { Checkbox } from './components/Checkbox';
import { toBooleanJN } from '../utils/functions/formatBoolean';

const LieferadressenTable = (props) => {
  const { id, readOnly } = props || {};
  let labels = (props || {}).labels || {};
  const { lieferadressenStorage, configStorage } = useStore().getState();
  const dispatch = useDispatch();
  const apiCall = configStorage.getApiRequest("changeLieferadresse");
  const [editMode, setEditMode] = useState(false);

  const changeMaxBetrag = useCallback((data) => {
    if (!data) return;
    if (typeof data.edit === "boolean") {
      setEditMode(data.edit);
    } else {
      setEditMode(false);
      const item = data.item;
      const attribute = data.shop + "MaxBetrag";
      dispatch(updateLieferadresse({
        apiCall, adresse: {
          lieferadressenNummer: item.lieferadressenNummer,
          [attribute]: data.value
        }
      }));
    }
  }, [apiCall, dispatch]);

  const changeLieferbarKz = useCallback((e) => {
    const target = e && (e.currentTarget || e.target);
    if (!target) return;
    const lieferadressenNummer = target.dataset.lieferadressennummer;
    const attribute = target.dataset.attribute;
    dispatch(updateLieferadresse({
      apiCall, adresse: {
        lieferadressenNummer,
        [attribute]: toBooleanJN(target.checked)
      }
    }));
  }, [apiCall, dispatch]);

  const renderAdresse = (item) => {
    // TODO: handle changed
    const changed = false;
    if (!item) return null;
    if (!item.beraterVerfuegbar && !item.kundeVerfuegbar) {
      return (
        <tr key={`row${item.lieferadressenNummer}${item.bezeichnungOnline}`} data-key={`row${item.lieferadressenNummer}${item.bezeichnungOnline}`} className="align-items-end">
          <td aria-label="Kennziffer" className="kennziffer">{item.lieferadressenNummer}</td>
          <td aria-label="Shops" className="shops">
            <div className="nowrap">{labels.Berater || ""}</div>
            <div className="nowrap">{labels.Kunde || ""}</div>
          </td>
          <td aria-label={labels["bezeichnung"]} className="bezeichnung">
            <div className="nowrap">{item.bezeichnungStationaer || "nicht verfügbar"}</div>
            <div className="nowrap">{item.bezeichnungOnline || "nicht verfügbar"}</div>
          </td>
          <td colspan="4">nicht verfügbar</td>
        </tr>
      );
    }
    return (
      <tr key={`row${item.lieferadressenNummer}${item.bezeichnungOnline}`} data-key={`row${item.lieferadressenNummer}${item.bezeichnungOnline}`} className="align-items-end">
        <td aria-label="Kennziffer" className="kennziffer">{item.lieferadressenNummer}</td>
        <td aria-label="Shops" className="shops">
          <div className="nowrap">{labels.Berater || ""}</div>
          <div className="nowrap">{labels.Kunde || ""}</div>
        </td>
        <td aria-label="Bezeichnung" className="bezeichnung">
          <div className="nowrap">{item.bezeichnungStationaer || "nicht verfügbar"}</div>
          <div className="nowrap">{item.bezeichnungOnline || "nicht verfügbar"}</div>
        </td>
        <td
          aria-label={labels["edelmetall"] || ""}
          className={"edelmetallKz" + (changed ? " dirty" : "")}
        >
          <Checkbox
            id={"edelmetallLieferbarKzBerater"}
            label={labels["edelmetallLieferbarKzBerater"]}
            adressenNummer={item.lieferadressenNummer}
            checked={item.edelmetallLieferbarKzBerater === "J"}
            editMode={editMode}
            readOnly={readOnly | !item.beraterVerfuegbar}
            onChange={changeLieferbarKz}
          />
          <Checkbox
            id={"edelmetallLieferbarKzKunde"}
            label={labels["edelmetallLieferbarKzKunde"]}
            adressenNummer={item.lieferadressenNummer}
            checked={item.edelmetallLieferbarKzKunde === "J"}
            editMode={editMode}
            readOnly={readOnly | !item.kundeVerfuegbar}
            onChange={changeLieferbarKz}
          />
        </td>
        <td
          aria-label={labels["edelmetallMaxBetrag"] || ""}
          className={"edelmetallMax" + (changed ? " dirty" : "")}
        >
          <MaxBetrag
            className="col"
            item={item}
            shop="edelmetall"
            label={labels["edelmetallMaxBetrag"]}
            value={item.edelmetallMaxBetrag}
            onChange={changeMaxBetrag}
            readOnly={readOnly}
            disabled={lieferadressenStorage.isUpdating() || editMode}
          />
        </td>
        <td
          aria-label={labels["sorten"] || ""}
          className={"sortenKz" + (changed ? " dirty" : "")}
        >
          <Checkbox
            id={"sortenLieferbarKzBerater"}
            label={labels["sortenLieferbarKzBerater"]}
            adressenNummer={item.lieferadressenNummer}
            checked={item.sortenLieferbarKzBerater === "J"}
            editMode={editMode}
            readOnly={readOnly | !item.beraterVerfuegbar}
            onChange={changeLieferbarKz}
          />
          <Checkbox
            id={"sortenLieferbarKzKunde"}
            label={labels["sortenLieferbarKzKunde"]}
            adressenNummer={item.lieferadressenNummer}
            checked={item.sortenLieferbarKzKunde === "J"}
            editMode={editMode}
            readOnly={readOnly | !item.kundeVerfuegbar}
            onChange={changeLieferbarKz}
          />
        </td>
        <td
          aria-label={labels["sortenMaxBetrag"] || ""}
          className={"sortenMax" + (changed ? " dirty" : "")}
        >
          <MaxBetrag
            className="col"
            item={item}
            shop="sorten"
            label={labels["edelmetalsortenMaxBetraglMaxBetrag"]}
            value={item.sortenMaxBetrag}
            onChange={changeMaxBetrag}
            readOnly={readOnly}
            disabled={lieferadressenStorage.isUpdating() || editMode}
          />
        </td>
      </tr>
    );
  };

  const liste = lieferadressenStorage.getListe();
  return <div>
    <Table id={id} striped bordered responsive>
      <TableHeader labels={labels} />
      <tbody>
        {liste.length
          ? liste.map(renderAdresse)
          : <tr><td colSpan={6}><div>Es wurden keine passenden Lieferadressen gefunden</div></td></tr>
        }
      </tbody>
    </Table>
  </div >;
};
export default LieferadressenTable;
